/* eslint-disable class-methods-use-this */

class FincTableSwitcher {
  constructor({
    rootEl,
  } = {}) {
    this.rootEl = rootEl;
    this.tableWrapEls = rootEl.querySelectorAll('.fincchta-table-wrapper');
    // this.radiobuttons = rootEl.querySelectorAll('input[type="radio"][name="table_switcher"]');

    this.init();
  }

  changeRadioAction(event) {
    this.tableWrapEls.forEach((element) => {
      if (element.getAttribute('data-name') === event.target.value) {
        element.setAttribute('aria-hidden', 'false');
      } else {
        element.setAttribute('aria-hidden', 'true');
      }
    });
  }

  init() {
    const radiobuttons = this.rootEl.querySelectorAll('input[type="radio"][name="table_switcher"]');
    [...radiobuttons].map((item) => item.addEventListener('change', (e) => { this.changeRadioAction(e); }));
  }
}

export default FincTableSwitcher;
